import { render, staticRenderFns } from "./CoreLayoutVertical.vue?vue&type=template&id=3abedfdc&"
import script from "./CoreLayoutVertical.vue?vue&type=script&lang=js&"
export * from "./CoreLayoutVertical.vue?vue&type=script&lang=js&"
import style0 from "./CoreLayoutVertical.vue?vue&type=style&index=0&id=3abedfdc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports